import React from 'react';
import FontSize from "./widgets/FontSizeSelector.js";
export default {
  matches: {
    use: 'MenuBar',
    client: 'CustomTextModelEditor'
  },
  id: 'Rich.Text.Editor.FontSize',
  handles: () => true,
  layout: {
    sort: 'I'
  },
  customComponent: props => {
    const {
      context: {
        editor
      }
    } = props;
    return /*#__PURE__*/React.createElement(FontSize, {
      ...props,
      disabled: !editor.can().chain().focus().setFontSize().run() || editor.isActive('code'),
      active: !!editor.getAttributes('textStyle').fontSize,
      value: editor.getAttributes('textStyle').fontSize,
      onChange: (value, editor) => {
        if (value) {
          editor.chain().focus().setFontSize(value).run();
        }
      }
    });
  }
};